import React, { useState } from 'react';
import '../styles/ContactSection.css';

// Import icons from assets
import locationIcon from '../assets/map.png';
import phoneIcon from '../assets/call.png';
import emailIcon from '../assets/gmail.png';
import clockIcon from '../assets/clock.png';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setSubmitStatus('success');
      setIsSubmitting(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
      
      // Reset success message after 5 seconds
      setTimeout(() => {
        setSubmitStatus(null);
      }, 5000);
    }, 1500);
  };

  const handleCallNow = () => {
    window.location.href = 'tel:+18334936242';
  };

  const contactInfo = [
    {
      icon: locationIcon,
      alt: 'Location',
      title: 'Visit Us',
      details: ['123 Pest Free Lane', 'Suite 200', 'New York, NY 10001']
    },
    {
      icon: phoneIcon,
      alt: 'Phone',
      title: 'Call Us',
      details: ['+1 (833) 493-6242']
    },
    {
      icon: emailIcon,
      alt: 'Email',
      title: 'Email Us',
      details: ['info@pestcontroltoday.com', 'support@pestcontroltoday.com']
    },
    {
      icon: clockIcon,
      alt: 'Business Hours',
      title: 'Business Hours',
      details: ['Mon - Fri: 8:00 AM - 8:00 PM', 'Sat: 9:00 AM - 6:00 PM', 'Sun: Closed']
    }
  ];

  const services = [
    'Select a Service',
    'General Pest Control',
    'Termite Treatment',
    'Bed Bug Extermination',
    'Rodent Removal',
    'Mosquito Control',
    'Commercial Services',
    'Eco-Friendly Treatment',
    'Preventive Maintenance'
  ];

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        {/* Section Header */}
        <div className="contact-header">
          <span className="contact-tag">Contact Us</span>
          <h2 className="contact-title">Get In Touch</h2>
          <p className="contact-subtitle">
            Have questions or ready to book? Reach out to us and we'll respond within 24 hours
          </p>
        </div>

        <div className="contact-content">
          {/* Contact Form */}
          <div className="contact-form-wrapper">
            <h3 className="contact-form-title">Send Us a Message</h3>
            
            {submitStatus === 'success' && (
              <div className="contact-success">
                <span className="success-icon">✅</span>
                <div>
                  <h4>Thank You!</h4>
                  <p>Your message has been sent successfully. We'll get back to you within 24 hours.</p>
                </div>
              </div>
            )}

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-form-row">
                <div className="contact-form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="John Doe"
                    required
                  />
                </div>
                <div className="contact-form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="john@example.com"
                    required
                  />
                </div>
              </div>

              <div className="contact-form-row">
                <div className="contact-form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+1 (833) 493-6242"
                  />
                </div>
                <div className="contact-form-group">
                  <label htmlFor="service">Service Interested In</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                  >
                    {services.map((service, index) => (
                      <option key={index} value={service}>
                        {service}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="contact-form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your pest problem or any questions you have..."
                  rows="5"
                  required
                />
              </div>

              <button 
                type="submit" 
                className="contact-submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Message →'}
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="contact-info-wrapper">
            <div className="contact-info-grid">
              {contactInfo.map((info, index) => (
                <div className="contact-info-card" key={index}>
                  <img 
                    src={info.icon} 
                    alt={info.alt} 
                    className="contact-info-icon-img"
                  />
                  <h4 className="contact-info-title">{info.title}</h4>
                  {info.details.map((detail, i) => (
                    <p className="contact-info-detail" key={i}>{detail}</p>
                  ))}
                  {info.title === 'Call Us' && (
                    <button className="contact-info-call-btn" onClick={handleCallNow}>
                      📞 Call Now
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Emergency CTA */}
        <div className="contact-emergency">
          <div className="contact-emergency-content">
            <span className="emergency-icon">🚨</span>
            <div>
              <h3>Need Immediate Help?</h3>
              <p>For emergency pest control service, call us 24/7</p>
            </div>
          </div>
          <button className="emergency-btn" onClick={handleCallNow}>
           📞 Call Now: +1 (833) 493-6242 
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;